import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import PostLoginLoader from "./PostLoginLoader";
import { canUseDashboard } from "../utils/roles";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user, logout } = useAuth();
  const location = useLocation();
  const [showPostLogin, setShowPostLogin] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) return;

    const justLoggedIn = sessionStorage.getItem("envoy:justLoggedIn") === "1";
    if (!justLoggedIn) return;

    setShowPostLogin(true);

    const t = setTimeout(() => {
      setShowPostLogin(false);
      sessionStorage.removeItem("envoy:justLoggedIn");
    }, 900);

    return () => clearTimeout(t);
  }, [isAuthenticated, location.pathname]);

  useEffect(() => {
    if (loading || !isAuthenticated || !user) return;
    if (!canUseDashboard(user)) {
      logout();
    }
    // logout is recreated each render; only re-run when auth/user changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, isAuthenticated, user]);

  if (showPostLogin) return <PostLoginLoader />;

  if (loading) return <PostLoginLoader />;

  if (!isAuthenticated) return <Navigate to="/login" />;

  if (user && !canUseDashboard(user)) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
